export default __webpack_public_path__ + "static/media/eventopedia_screenshot.d408137d.png";